import { useMemo } from 'react';

export const useTotalRevenue = (orders) => {
    return useMemo(() => {
        if (!orders) return;

        if (Array.isArray(orders)) {
            let totalRevenue = orders.reduce((total, o) => {
                return total + o.order_revenue;
            }, 0);
            return totalRevenue?.toFixed(2);
        }

        return orders?.order_revenue ? orders?.order_revenue?.toFixed(2) : null;
    }, [orders]);
};
